import { Text, BannerAlert } from "@amzn/storm-ui";
import { JSONPath } from "jsonpath-plus";
import React from "react";
import { JsonView, defaultStyles } from "react-json-view-lite";

import { ComponentLabel } from "../../../common/styled.components";

import type {
    VisualizationComponentProps,
    VisualizationTypes,
} from "./formatHandler";

import "react-json-view-lite/dist/index.css";

export interface JsonVisualizationConfiguration {
    type: VisualizationTypes.JSON;
    settings: {
        jsonPath?: string;
        parseJsonPathValue?: boolean;
    };
}

export interface JsonVisualizationProps
    extends VisualizationComponentProps,
        JsonVisualizationConfiguration {}

export const JsonVisualization: React.FunctionComponent<
    JsonVisualizationProps
> = (props) => {
    const { input, label, settings } = props;
    let data = settings.jsonPath
        ? JSONPath({
              path: settings.jsonPath,
              wrap: false,
              json: input,
          })
        : input;

    if (settings.parseJsonPathValue) {
        try {
            data = JSON.parse(data);
        } catch {
            return (
                <div>
                    <ComponentLabel>{label}</ComponentLabel>
                    <BannerAlert variant="error" withCloseButton={false}>
                        <Text>Error in parsing json</Text>
                    </BannerAlert>
                </div>
            );
        }
    }

    return (
        <div>
            <ComponentLabel>{label}</ComponentLabel>
            <JsonView data={data} style={defaultStyles} />
        </div>
    );
};
